module.exports = __webpack_public_path__ + "img/frontendsource_html.faeff815.svg";